
import React from "react";
import KempsRidleyImg from "../Images/Kemps-Ridley-B.jpg";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#99aab5", // custom primary color
    },
    secondary: {
      main: "#F27920", // custom secondary color
    },
  },
});

export default function KempsRidley() {
  return (
    <div className="p-5 w-full h-full">
      <div>

        <h2 className="text-2xl font-bold text-[#F27920] pb-5">Kemp's Ridley Sea Turtles</h2>

      </div>
      <div className="lg:float-left lg:w-1/3 mb-5 lg:mr-5">
        <img className="rounded-3xl shadow-lg" src={KempsRidleyImg} alt="" title="" />
      </div>
      <div>

        The rarest and smallest of all the sea turtles, the endangered Kemp's Ridley feeds in the
        coastal waters of Florida on blue crabs and other crabs and shrimp. All Kemp's
        Ridley&nbsp;s nest on a single stretch of beach on the Gulf Coast of Mexico.

      </div>
      <div className="my-5 text-right  mt-24">
        <ThemeProvider theme={theme}>
          <Button color="secondary" variant="contained">
            <Link href="/SeaTurtles/KempsRidley" title="Kemps Ridley Sea Turtles" style={{ color: '#ffffff' }}>

              More about Kemp's Ridley Sea Turtles

            </Link>
          </Button>
        </ThemeProvider>
      </div>
    </div >
  );
}
